import { useDropEvent } from 'root/src/client/logic/dropEvent/hooks/useDropEvent';
import { useUserCreatorData } from 'root/src/client/logic/auth/hooks/useUser';
// Return platforms that contain userConnectedPlatforms existing in daresPlatforms,
// If all dares platforms are 'any', then return an array with one platform where the user can accept a maximum of maxDares.
// If daresCount is 0, then return an empty array, indicating that the user can't accept any dares.
export function useViewershipPlatformsByDares(recordId, fallbackDrop) {
    var _a;
    const campaign = (_a = useDropEvent(recordId)) !== null && _a !== void 0 ? _a : fallbackDrop;
    const { viewershipPlatforms } = useUserCreatorData();
    if (!campaign) {
        return { viewershipPlatformsByDares: [] };
    }
    const daresPlatforms = getDaresPlatforms(campaign.dares);
    if (daresPlatforms.length === 0) {
        return { viewershipPlatformsByDares: [] };
    }
    const viewershipPlatformsByDares = viewershipPlatforms.filter(connectedPlatform => daresPlatforms.includes(connectedPlatform));
    return { viewershipPlatformsByDares };
}
export function getDaresPlatforms(dares) {
    const platforms = new Set(dares.flatMap(dare => dare.platforms));
    return Array.from(platforms);
}
